import { struct } from 'io-ts/Decoder';

import { Id as StatusId } from '../../../../job/status/Id';

export const Request = struct({
	statusId: StatusId,
});
